import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function OfficeSection() {
  const { t } = useTranslation(['ui', 'intro'])
  const text = 'intro:sections.office'

  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const onPress = () => router.navigate('/deals?tag=office')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/strategy/office.png'),
            imageStyle: {
              opacity: 1,
              transformOrigin: 'right',
              transform: [
                { translateX: Platform.select({ default: 100, web: 75 }) },
                { translateY: 0 },
              ],
            },
            blur: Platform.select({ default: 100, web: 25 }),
            blurStyle: {
              opacity: 0.5,
              transformOrigin: 'center',
              transform: [
                { translateX: 0 },
                { translateY: 100 },
                { scale: 0.5 },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
